/** UI copy. English strings stay identical to the previous interface so existing tests keep matching. */
export const en = {
  skip: 'Skip to main content',
  productName: 'Mekum Founder OS',
  language: 'Language',
  signIn: 'Sign in',
  signingIn: 'Signing in…',
  email: 'Email',
  password: 'Password',
  enterPassword: 'Enter your password.',
  magicLink: 'Email me a sign-in link instead',
  forgotPassword: 'Forgot your password?',
  passwordUpdated: 'Your password was updated. Sign in with your new password.',
  pleaseSignIn: 'Please sign in to continue.',
  signOut: 'Sign out',
  signingOut: 'Signing out…',
  profile: 'Profile',
  security: 'Security',
  accountMenu: 'Account menu for',
  loadingSession: 'Loading your session…',
  navWorkspace: 'Workspace',
  navMenu: 'Menu',
  navHome: 'Home',
  navTopics: 'Topics',
  navDecisions: 'Decisions',
  navTasks: 'Tasks',
  navUpdates: 'Updates',
  navMeetings: 'Meetings',
  navGoals: 'Goals',
  navSearch: 'Search',
  navReports: 'Reports',
  navExecution: 'Execution',
  navFounders: 'Founders',
  navFinance: 'Finance',
  navAdmin: 'Admin',
  notifications: 'Notifications',
  loadingCabinet: 'Loading your cabinet…',
  cabinetError: 'Your cabinet could not be loaded',
  loadingFigures: 'Loading company figures…',
  figuresError: 'Company figures could not be loaded',
  companyPosition: 'Company position',
  waiting: 'Waiting for me',
  nothingWaiting: 'Nothing is waiting for you right now.',
  outstandingList: 'Outstanding actions, most urgent first',
  urgent: 'Urgent',
  soon: 'Soon',
  forInformation: 'For information',
  due: 'Due',
  myTasks: 'My open tasks',
  noTasks: 'You own no open tasks.',
  myTasksList: 'My open tasks, earliest deadline first',
  blocked: 'Blocked',
  allTasks: 'All my tasks',
  myEquity: 'My equity',
  noFounderProfile: 'You do not have a founder profile in this workspace.',
  responsibilities: 'My responsibilities',
  noResponsibilities: 'No responsibilities recorded yet.',
  membership: 'My membership',
  role: 'Role',
  title: 'Title',
  status: 'Status',
  joined: 'Joined',
  twoStep: 'Two-step verification',
  enabled: 'Enabled',
  notEnabled: 'Not enabled',
  manage: 'Manage',
  notSet: 'Not set',
  workspaceReports: 'Workspace reports',
  roleOwner: 'Owner',
  roleFounder: 'Founder',
  roleExecutive: 'Executive',
  roleObserver: 'Observer',
  thisMonth: 'This month',
  openPnl: 'Open the P&L',
  journalAsOf: 'From the journal as of',
  resultIs: 'Result is revenue minus expenses.',
  noIncome: 'No income or expenses recorded this month.',
  currency: 'Currency',
  income: 'Income',
  expenses: 'Expenses',
  result: 'Result',
  cash: 'Cash',
  openCash: 'Open cash accounts',
  cashMeta: 'Book balances from the journal. Operating cash is what reserve uses.',
  noCash: 'No cash accounts yet.',
  reserve: 'Reserve and distributable cash',
  openReserve: 'Open the reserve',
  reserveMeta:
    'Distributable cash is what the reserve policy and restrictions leave. A distribution still needs a founder decision before anyone is paid.',
  noReserve: 'No currency has operating cash to measure yet.',
  fundingDue: 'Funding due',
  openFunding: 'Open funding',
  noFunding: 'No funding calls are due in this period.',
  latestValuation: 'Latest valuation',
  openValuations: 'Open valuations',
  noValuation: 'No valuation snapshot yet.',
  mfaRecommendedTitle: 'Protect your account with two-factor authentication',
  mfaRecommendedDetail:
    'Founders approve equity and financial decisions; a second factor is strongly recommended.',
  noReportingCurrency: 'No reporting currency is set, so amounts stay in their own currencies.',
  displayName: 'Display name',
  timeZone: 'Time zone',
  signedInAs: 'Signed in as',
  timeZoneHint: 'IANA time zone used to show dates and times, e.g. Asia/Yerevan.',
  useDeviceZone: 'Use this device’s zone',
  nameError: 'Enter a name (up to 200 characters).',
  zoneError: 'Unknown time zone. Use an IANA name such as Asia/Yerevan.',
  nothingToSave: 'Nothing to save — no changes were made.',
  profileSaved: 'Profile saved.',
  saving: 'Saving…',
  saveProfile: 'Save profile',
  languageHint: 'Armenian, Russian and English. Dates follow this choice.',
  topicsLead: 'Questions the founders are discussing, voting on or executing.',
  newTopic: 'New topic',
  filterTopics: 'Filter topics',
  show: 'Show',
  activeTopics: 'Active topics',
  closedTopics: 'Closed topics',
  allTopics: 'All topics',
  anyStatus: 'Any status',
  priority: 'Priority',
  anyPriority: 'Any priority',
  category: 'Category',
  anyCategory: 'Any category',
  involvement: 'Involvement',
  everyonesTopics: "Everyone's topics",
  topicsIOwn: 'Topics I own',
  topicsIJoin: 'Topics I participate in',
  searchHint: 'Title, context and desired outcome.',
  clearFilters: 'Clear filters',
  results: 'Results',
  loadingTopics: 'Loading topics…',
  topicsError: 'Topics could not be loaded',
  topicsNone: 'No topics match these filters.',
  loadMoreTopics: 'Load more topics',
  loading: 'Loading…',
  searchTooShort: 'Enter at least 2 characters, or clear the search.',
  votePending: 'Your vote is pending',
  awaitingInput: 'Awaiting your input',
  restricted: 'Restricted',
  following: 'Following',
  deadline: 'Deadline',
  comments: 'Comments',
  notAssigned: 'Not assigned',
  priorityLow: 'Low',
  priorityNormal: 'Normal',
  priorityHigh: 'High',
  priorityCritical: 'Critical',
  statusDraft: 'Draft',
  statusOpen: 'Open',
  statusDiscussing: 'Discussing',
  statusAwaitingVote: 'Awaiting vote',
  statusDecided: 'Decided',
  statusExecution: 'In execution',
  statusClosed: 'Closed',
  statusDeferred: 'Deferred',
  statusCancelled: 'Cancelled',
  statusMeeting: 'Meeting required',
  statusNoAction: 'No action',
  statusQuorum: 'Quorum not reached',
  workspaceSearch: 'Workspace search',
  headerSearchLabel: 'Search topics, decisions, tasks, updates, meetings and goals',
  searchPlaceholder: 'Search…',
  decisionRegister: 'Decision register',
  decisionsLead:
    'Every recorded decision with its source, rule and follow-up actions. Finalized decisions are immutable.',
  recordDecision: 'Record decision',
  exportCsv: 'Export CSV',
  exportDecisionsHidden: ' of the filtered decisions',
  filterDecisions: 'Filter decisions',
  type: 'Type',
  anyType: 'Any type',
  decisionsSearchHint: 'Title, statement and rationale.',
  loadingDecisions: 'Loading decisions…',
  decisionsError: 'Decisions could not be loaded',
  decisionsNone: 'No decisions match these filters.',
  loadMoreDecisions: 'Load more decisions',
  sourceTopic: 'Source topic',
  none: 'None',
  decided: 'Decided',
  notYet: 'Not yet',
  effective: 'Effective',
  votePrefix: 'Vote: ',
  typeSimple: 'Simple approval (vote)',
  typeChoice: 'Multiple choice (vote)',
  typeConsensus: 'Consensus (vote)',
  typeOwner: 'Owner decision',
  typeInfo: 'Informational',
  typeEmergency: 'Emergency',
  statusFinalized: 'Finalized',
  statusDiscarded: 'Discarded',
  tasksLead: 'Action items with one accountable owner, deadlines, blockers and history.',
  newTask: 'New task',
  blockersWaiting: 'Blockers waiting for me',
  taskViews: 'Task views',
  tasksMine: 'My tasks',
  tasksTeam: 'All visible tasks',
  tasksWatching: 'Collaborating or watching',
  tasksCreated: 'Created by me',
  filterTasks: 'Filter tasks',
  openTasks: 'Open tasks (not done)',
  tasksSearchHint: 'Title and description.',
  onlyOverdue: 'Only overdue tasks',
  loadingTasks: 'Loading tasks…',
  tasksError: 'Tasks could not be loaded',
  tasksNone: 'No tasks match these filters.',
  loadMoreTasks: 'Load more tasks',
  fromDecision: 'From decision',
  openDecision: 'Open decision',
  openTopic: 'Open topic',
  statusDone: 'Done',
  statusCancelledArchived: 'Cancelled or archived',
  statusBacklog: 'Backlog',
  statusPlanned: 'Planned',
  statusInProgress: 'In progress',
  statusBlocked: 'Blocked',
  statusInReview: 'In review',
  statusArchived: 'Archived',
  priorityLowFull: 'Low priority',
  priorityNormalFull: 'Normal priority',
  priorityHighFull: 'High priority',
  priorityCriticalFull: 'Critical priority',
  noDeadline: 'No deadline',
  deadlineNotSet: 'Deadline not set',
  overdue: 'Overdue',
  meetingsLead:
    'Topics that need a live discussion wait in a ranked queue; every agenda item leaves a meeting with a decision, task, deferral, no-action note or follow-up topic.',
  newMeeting: 'New meeting',
  requestAgenda: 'Request agenda time…',
  requestAdded: 'Your request was added to the agenda queue.',
  meetingViews: 'Meeting views',
  agendaQueue: 'Agenda queue',
  upcomingMeetings: 'Upcoming meetings',
  pastMeetings: 'Past meetings',
  waitingForMeeting: 'Waiting for a meeting',
  queueRank:
    'Ranked by priority, then deadline (passed deadlines first), then how long the item has waited.',
  loadingQueue: 'Loading the agenda queue…',
  queueError: 'The queue could not be loaded',
  queueEmpty:
    'Nothing is waiting. Topics marked “Meeting required” and explicit requests appear here.',
  agendaQueueList: 'Agenda queue, highest rank first',
  withdrawTitle: 'Withdraw this request?',
  withdrawConfirm: 'Withdraw request',
  loadingMeetings: 'Loading meetings…',
  meetingsError: 'Meetings could not be loaded',
  noUpcoming: 'No meetings are planned. Organizers can plan one from the agenda queue.',
  noPast: 'No completed or cancelled meetings yet.',
  loadMoreMeetings: 'Load more meetings',
  goalsLead:
    'Quarterly and annual objectives with optional key results. Goals give direction to topics, decisions and tasks; they never block work.',
  newGoal: 'New goal',
  filterGoals: 'Filter goals',
  horizon: 'Horizon',
  anyHorizon: 'Any horizon',
  includeArchived: 'Include archived goals',
  loadingGoals: 'Loading goals…',
  goalsError: 'Goals could not be loaded',
  goalsNone: 'No goals match these filters.',
  goalsOpen: 'In progress',
  goalsAll: 'All except cancelled',
  goalsDrafts: 'Drafts',
  goalsClosed: 'Closed (achieved or missed)',
  keyResults: 'Key results',
  progress: 'Progress',
  period: 'Period',
  quarterly: 'Quarterly',
  annual: 'Annual',
  customPeriod: 'Custom period',
  statusAtRisk: 'At risk',
  statusActive: 'Active',
  statusAchieved: 'Achieved',
  statusMissed: 'Missed',
  myUpdate: 'My update',
  updatesLead: 'Done, Next, Blockers and Need decision — with links to the work itself.',
  teamUpdates: 'Team updates',
  loadingUpdate: 'Loading your update…',
  updatesOff:
    'Weekly updates are not switched on. The reporting cadence and the required sections are a founder decision that has not been recorded yet.',
  setSchedule: 'Set the reporting schedule',
  noOpenPeriod: 'No reporting period is open yet. The first period starts on the configured date.',
  searchLead:
    'Topics, comments, decisions, tasks, weekly updates, meeting minutes and goals you are allowed to see. Partial words and small typos are matched; use T-12, D-3 or #7 to jump to a numbered item.',
  howToSearch: 'How to search',
  wordsAndFilters: 'Words and filters',
  askPlain: 'Ask a question in plain language',
  searchFor: 'Search for',
  searchKinds: 'Only these kinds (none checked = all)',
  kindTopic: 'Topic',
  kindComment: 'Comment',
  kindDecision: 'Decision',
  kindTask: 'Task',
  kindUpdate: 'Weekly update',
  kindMeeting: 'Meeting',
  kindGoal: 'Goal',
  authorOrOwner: 'Author or owner',
  anyone: 'Anyone',
  createdFrom: 'Created from',
  createdTo: 'Created to',
  searchWorkspace: 'Search the workspace',
  clear: 'Clear',
  searching: 'Searching…',
  searchFailed: 'Search failed',
  searchResults: 'Search results',
  enterToSearch: 'Enter a word, a phrase or a reference to search.',
  searchMin: 'Enter at least 2 characters.',
  toAfterFrom: '“To” must be on or after “from”.',
  reportsLead:
    'What needs attention, then recorded counts and amounts. Founders are listed alphabetically.',
  exportReportHidden: ' of this workspace report',
  asOf: 'As of',
  loadingReports: 'Loading workspace reports…',
  reportsError: 'Workspace reports could not be loaded',
  executionLead:
    'Open work, overdue items, blockers and reporting, side by side. People are listed alphabetically, with counts of open, overdue and blocked work.',
  loadingDashboard: 'Loading the dashboard…',
  loadingFounders: 'Loading founders…',
  foundersError: 'Founders could not be loaded',
  noFounders: 'No founder profiles yet.',
  name: 'Name',
  roleAndTitle: 'Role and title',
  founderSince: 'Founder since',
  ownership: 'Ownership',
  effectiveFrom: 'Effective from',
  source: 'Source',
  companyFinance: 'Company finance',
  financeLead:
    'Management view of income, expenses and cash. Every figure is computed from the immutable journal; corrections are reversals, never edits.',
  loadingSection: 'Loading section…',
  financeSections: 'Finance sections',
  overview: 'Overview',
  incomeExpenses: 'Income & expenses',
  monthlyPnl: 'Monthly P&L',
  cashFx: 'Cash & FX',
  reconciliation: 'Reconciliation',
  founderFunding: 'Founder funding',
  reserveDistributions: 'Reserve & distributions',
  valuation: 'Valuation',
  loadingFinance: 'Loading the finance overview…',
  financeOverviewError: 'The finance overview could not be loaded',
  recordIncome: 'Record income or expense',
  needsAttention: 'Needs attention',
  nothingAttention: 'Nothing needs attention right now.',
  warning: 'Warning',
  review: 'Review',
  administration: 'Administration',
  adminSections: 'Administration sections',
  adminGroupPeople: 'People & access',
  adminGroupOwnership: 'Ownership & money',
  adminGroupOversight: 'Oversight',
  adminGroupSettings: 'Workspace settings',
  adminMembers: 'Members',
  adminInvitations: 'Invitations',
  adminPermissions: 'Permission grants',
  adminEquity: 'Equity',
  adminGovernance: 'Governance',
  adminAudit: 'Audit log',
  adminAi: 'AI activity',
  adminExecution: 'Execution & reporting',
  adminSecurity: 'Security settings',
  adminSystem: 'System status',
  notificationsLead: 'Votes, mentions, decisions and deadlines that concern you.',
  notificationSettings: 'Notification settings',
  markAllRead: 'Mark all as read',
  unreadOnly: 'Show unread only',
  loadingNotifications: 'Loading notifications…',
  notificationsError: 'Notifications could not be loaded',
  noUnread: 'You have no unread notifications.',
  nothingUnread: 'Nothing unread.',
  noNotificationsYet: 'No notifications yet.',
  meetingNotScheduled: 'Not scheduled yet',
  meetingScheduled: 'Scheduled',
  meetingCompleted: 'Completed',
  cancel: 'Cancel',
  reason: 'Reason',
  reasonMin: 'Enter a reason of at least 3 characters.',
  recordedInAudit: 'Recorded in the audit log.',
  working: 'Working…',
  actions: 'Actions',
  when: 'When',
  applyFilters: 'Apply filters',
  loadMore: 'Load more',
  on: 'On',
  off: 'Off',
  member: 'Member',
  saveChanges: 'Save changes',
  saveSettings: 'Save settings',
  checkingServices: 'Checking services…',
  apiUnreachable: 'The API cannot be reached. Make sure it is running.',
  statusUnknown: 'Service status could not be determined.',
  allOperational: 'All services are operational.',
  someUnavailable: 'Some services are unavailable.',
  operational: 'Operational',
  unavailable: 'Unavailable',
  database: 'Database',
  cacheQueues: 'Cache & queues',
  checkAgain: 'Check again',
  checking: 'Checking…',
  loadingAudit: 'Loading audit events…',
  auditNone: 'No audit events match these filters.',
  auditEvents: 'Audit events',
  action: 'Action',
  entity: 'Entity',
  actor: 'Actor',
  details: 'Details',
  showChanges: 'Show changes',
  before: 'Before',
  after: 'After',
  filterAudit: 'Filter audit events',
  entityType: 'Entity type',
  entityTypeHint: 'e.g. member, founder_profile, cap_table_version',
  entityTypeError: 'Use lowercase letters and underscores, e.g. member or cap_table_version.',
  entityId: 'Entity ID',
  entityIdError: 'Use a full ID (UUID).',
  aiConfigError: 'The AI configuration could not be loaded',
  aiLead:
    'Each request to the AI provider is listed with its model, prompt template version and data policy. Prompts and answers are not stored in this log.',
  loadingAi: 'Loading AI activity…',
  aiNone: 'The AI assistant has not been used yet.',
  aiActivity: 'AI activity',
  purpose: 'Purpose',
  requestedBy: 'Requested by',
  model: 'Model',
  dataCol: 'Data',
  usage: 'Usage',
  plainSearch: 'Plain-language search',
  systemActor: 'System',
  notSent: 'Not sent',
  sentWorkspace: 'Sent (workspace content)',
  sentAggregates: 'Sent (aggregated figures only)',
  aiConfiguration: 'AI configuration',
  provider: 'Provider',
  notConfigured: 'Not configured',
  workspaceContent: 'Workspace content',
  mayBeSent: 'May be sent',
  neverSent: 'Never sent',
  financialFigures: 'Financial figures',
  aggregatesMay: 'Aggregates may be sent',
  aiEnvNote:
    'These settings come from the server environment (AI_PROVIDER, AI_CONTENT_DATA_POLICY, AI_FINANCE_DATA_POLICY) and change only with a deployment.',
  loadingSecurity: 'Loading security settings…',
  securitySaved: 'Security settings saved.',
  mfaForFounders: 'Two-step verification for owner and founders:',
  required: 'Required',
  optional: 'Optional',
  requireMfa: 'Require two-step verification for the owner and founders',
  requireMfaHint: 'Members without it will be asked to enroll before continuing sensitive work.',
  requireMfaTitle: 'Require two-step verification?',
  optionalMfaTitle: 'Make two-step verification optional?',
  requireMfaDesc:
    'Founders and the owner without two-step verification will have to set it up before continuing.',
  optionalMfaDesc: 'This lowers the workspace security requirement. The change is audited.',
  saveSetting: 'Save setting',
  policyLead:
    'How the workspace delivers notifications by e-mail. Members choose their own channels and quiet hours; governance-critical notifications are always delivered.',
  loadingPolicy: 'Loading notification policy…',
  emailDelivery: 'E-mail delivery and escalation',
  defaultsInEffect: 'Documented defaults in effect',
  savedByWorkspace: 'Saved by the workspace',
  bundleEmails: 'Bundle non-critical e-mails for (minutes)',
  bundleHint: 'Events within this window go out as one e-mail. 0 = send each at once.',
  bundleError: 'Enter a whole number from 0 to 240.',
  remindCritical: 'Remind about unread critical notifications every (hours)',
  remindHint: 'Votes, critical topics and finalized decisions. 0 = no reminders.',
  remindError: 'Enter a whole number from 0 to 336.',
  maxReminders: 'Maximum reminders per notification',
  maxRemindersHint: 'Stops escalating after this many reminders.',
  maxRemindersError: 'Enter a whole number from 0 to 10.',
  policySaved: 'Notification policy saved.',
  savePolicyButton: 'Save notification policy…',
  savePolicyTitle: 'Save the notification policy?',
  savePolicyDesc: 'New values apply to notifications created from now on. The change is audited.',
  savePolicy: 'Save policy',
  loadingMembers: 'Loading members…',
  twoStepCol: 'Two-step',
  deactivate: 'Deactivate',
  reactivate: 'Reactivate',
  edit: 'Edit',
  deactivateDesc:
    'They will lose access to this workspace immediately. Their history, votes, debts and records are kept.',
  reactivateDesc: 'They will regain access with their current role.',
  deactivateMember: 'Deactivate member',
  reactivateMember: 'Reactivate member',
  titleHint: 'Leave empty to remove the title.',
  ownerRoleFixed: 'The owner role cannot be changed here.',
  roleChangeHint: 'Role changes need recent identity confirmation and are audited.',
  roleChangeReason: 'Reason for the role change',
  changeFirst: 'Change the title or role first.',
  sentInvitations: 'Sent invitations',
  loadingInvitations: 'Loading invitations…',
  resendFailed: 'Resend failed',
  noInvitations: 'No invitations yet.',
  expires: 'Expires',
  invitedBy: 'Invited by',
  resend: 'Resend',
  revoke: 'Revoke',
  revokeInvitation: 'Revoke invitation?',
  revokeInvitationDesc: 'The link stops working. You can invite this address again later.',
  revokeInvitationConfirm: 'Revoke invitation',
  inviteSomeone: 'Invite someone',
  titleOptionalHint: 'Optional, e.g. CTO.',
  sendInvitation: 'Send invitation',
  invitationSent: 'Invitation created.',
  grantsLead:
    'Grants extend a member’s role with one explicit permission. Granting and revoking need recent identity confirmation and are audited.',
  grants: 'Grants',
  noGrants: 'No permission grants.',
  permission: 'Permission',
  grantedBy: 'Granted by',
  active: 'Active',
  revoked: 'Revoked',
  revokePermission: 'Revoke permission?',
  grantPermission: 'Grant a permission',
  membersLoadError: 'Members could not be loaded',
  chooseMember: 'Choose a member',
  choosePermission: 'Choose a permission',
  decisionId: 'Decision ID',
  decisionIdHint: 'Optional: ID of the founder decision that approved this grant.',
  grantThis: 'Grant this permission?',
  founderProfiles: 'Founder profiles',
  createFounder: 'Create a founder profile',
  everyMemberHasProfile: 'Every active member already has a founder profile.',
  capAsOf: 'Show cap table as of',
  capAsOfHint:
    'Leave empty for today. The version in effect is the approved one with the latest effective date on or before this day.',
  noCapVersions: 'No cap table versions yet. Create the first draft above.',
  tasksAndBlockers: 'Tasks and blockers',
  weeklyFounderUpdates: 'Weekly founder updates',
  reportingRules: 'Reporting rules',
  categories: 'Categories',
  noCategories: 'No categories yet.',
  dataSources: 'Data sources',
  categoryPolicies: 'Category policies',
} as const;

export type MessageKey = keyof typeof en;

export const hy: Record<MessageKey, string> = {
  skip: 'Անցնել հիմնական բովանդակությանը',
  productName: 'Mekum Founder OS',
  language: 'Լեզու',
  signIn: 'Մուտք',
  signingIn: 'Մուտք է կատարվում…',
  email: 'Էլ. փոստ',
  password: 'Գաղտնաբառ',
  enterPassword: 'Մուտքագրեք գաղտնաբառը։',
  magicLink: 'Ուղարկել մուտքի հղում',
  forgotPassword: 'Մոռացե՞լ եք գաղտնաբառը',
  passwordUpdated: 'Գաղտնաբառը թարմացվել է։ Մուտք գործեք նոր գաղտնաբառով։',
  pleaseSignIn: 'Շարունակելու համար մուտք գործեք։',
  signOut: 'Դուրս գալ',
  signingOut: 'Դուրս է գրվում…',
  profile: 'Պրոֆիլ',
  security: 'Անվտանգություն',
  accountMenu: 'Հաշվի ընտրացանկ՝',
  loadingSession: 'Նիստը բեռնվում է…',
  navWorkspace: 'Աշխատատիրույթ',
  navMenu: 'Ընտրացանկ',
  navHome: 'Գլխավոր',
  navTopics: 'Թեմաներ',
  navDecisions: 'Որոշումներ',
  navTasks: 'Առաջադրանքներ',
  navUpdates: 'Թարմացումներ',
  navMeetings: 'Հանդիպումներ',
  navGoals: 'Նպատակներ',
  navSearch: 'Որոնում',
  navReports: 'Հաշվետվություններ',
  navExecution: 'Կատարում',
  navFounders: 'Հիմնադիրներ',
  navFinance: 'Ֆինանսներ',
  navAdmin: 'Կառավարում',
  notifications: 'Ծանուցումներ',
  loadingCabinet: 'Գլխավոր էջը բեռնվում է…',
  cabinetError: 'Գլխավոր էջը չհաջողվեց բեռնել',
  loadingFigures: 'Ընկերության ցուցանիշները բեռնվում են…',
  figuresError: 'Ընկերության ցուցանիշները չհաջողվեց բեռնել',
  companyPosition: 'Ընկերության վիճակ',
  waiting: 'Սպասում է ինձ',
  nothingWaiting: 'Այս պահին ձեզնից ոչինչ չի սպասվում։',
  outstandingList: 'Սպասվող գործողություններ, նախ հրատապները',
  urgent: 'Հրատապ',
  soon: 'Շուտով',
  forInformation: 'Տեղեկատվության համար',
  due: 'Ժամկետ',
  myTasks: 'Իմ բաց առաջադրանքները',
  noTasks: 'Դուք բաց առաջադրանք չունեք։',
  myTasksList: 'Իմ բաց առաջադրանքները, նախ մոտակա ժամկետով',
  blocked: 'Արգելափակված',
  allTasks: 'Բոլոր առաջադրանքներս',
  myEquity: 'Իմ բաժնեմասը',
  noFounderProfile: 'Այս աշխատատիրույթում հիմնադրի պրոֆիլ չունեք։',
  responsibilities: 'Իմ պարտականությունները',
  noResponsibilities: 'Պարտականություններ դեռ չեն գրանցվել։',
  membership: 'Իմ անդամակցությունը',
  role: 'Դեր',
  title: 'Պաշտոն',
  status: 'Կարգավիճակ',
  joined: 'Միացել է',
  twoStep: 'Երկքայլ հաստատում',
  enabled: 'Միացված է',
  notEnabled: 'Միացված չէ',
  manage: 'Կառավարել',
  notSet: 'Նշված չէ',
  workspaceReports: 'Աշխատատիրույթի հաշվետվություններ',
  roleOwner: 'Սեփականատեր',
  roleFounder: 'Հիմնադիր',
  roleExecutive: 'Ղեկավար',
  roleObserver: 'Դիտորդ',
  thisMonth: 'Այս ամիս',
  openPnl: 'Բացել շահույթն ու վնասը',
  journalAsOf: 'Մատյանի տվյալներով՝',
  resultIs: 'Արդյունքը եկամուտն է՝ հանած ծախսերը։',
  noIncome: 'Այս ամիս եկամուտ կամ ծախս չի գրանցվել։',
  currency: 'Արժույթ',
  income: 'Եկամուտ',
  expenses: 'Ծախսեր',
  result: 'Արդյունք',
  cash: 'Դրամական միջոցներ',
  openCash: 'Բացել դրամական հաշիվները',
  cashMeta:
    'Մնացորդները մատյանից են։ Գործառնական դրամական միջոցներն են, որոնցից հաշվարկվում է պահուստը։',
  noCash: 'Դրամական հաշիվներ դեռ չկան։',
  reserve: 'Պահուստ և բաշխելի դրամական միջոցներ',
  openReserve: 'Բացել պահուստը',
  reserveMeta:
    'Բաշխելի գումարը այն է, ինչ մնում է պահուստի քաղաքականությունից և սահմանափակումներից հետո։ Բաշխումը միևնույն է պահանջում է հիմնադիրների որոշում։',
  noReserve: 'Դեռ չկա արժույթ՝ գործառնական դրամական միջոցներով։',
  fundingDue: 'Վճարման ենթակա ֆինանսավորում',
  openFunding: 'Բացել ֆինանսավորումը',
  noFunding: 'Այս ժամանակահատվածում վճարման ենթակա կանչեր չկան։',
  latestValuation: 'Վերջին գնահատումը',
  openValuations: 'Բացել գնահատումները',
  noValuation: 'Գնահատում դեռ չկա։',
  mfaRecommendedTitle: 'Պաշտպանեք հաշիվը երկգործոն նույնականացմամբ',
  mfaRecommendedDetail:
    'Հիմնադիրները հաստատում են բաժնեմասի և ֆինանսական որոշումները. երկրորդ գործոնը խիստ ցանկալի է։',
  noReportingCurrency:
    'Հաշվետվական արժույթ սահմանված չէ, ուստի գումարները մնում են իրենց արժույթով։',
  displayName: 'Ցուցադրվող անուն',
  timeZone: 'Ժամային գոտի',
  signedInAs: 'Մուտք եք գործել որպես',
  timeZoneHint: 'Ամսաթվերը ցույց տալու IANA ժամային գոտի, օրինակ՝ Asia/Yerevan։',
  useDeviceZone: 'Օգտագործել այս սարքի գոտին',
  nameError: 'Մուտքագրեք անուն (մինչև 200 նիշ)։',
  zoneError: 'Անհայտ ժամային գոտի։ Օգտագործեք IANA անուն, օրինակ՝ Asia/Yerevan։',
  nothingToSave: 'Պահելու բան չկա. փոփոխություն չի արվել։',
  profileSaved: 'Պրոֆիլը պահվել է։',
  saving: 'Պահվում է…',
  saveProfile: 'Պահել պրոֆիլը',
  languageHint: 'Հայերեն, ռուսերեն և անգլերեն։ Ամսաթվերը հետևում են այս ընտրությանը։',
  topicsLead: 'Հարցեր, որոնք հիմնադիրները քննարկում, քվեարկում կամ կատարում են։',
  newTopic: 'Նոր թեմա',
  filterTopics: 'Զտել թեմաները',
  show: 'Ցույց տալ',
  activeTopics: 'Ակտիվ թեմաներ',
  closedTopics: 'Փակված թեմաներ',
  allTopics: 'Բոլոր թեմաները',
  anyStatus: 'Ցանկացած կարգավիճակ',
  priority: 'Առաջնահերթություն',
  anyPriority: 'Ցանկացած առաջնահերթություն',
  category: 'Կատեգորիա',
  anyCategory: 'Ցանկացած կատեգորիա',
  involvement: 'Մասնակցություն',
  everyonesTopics: 'Բոլորի թեմաները',
  topicsIOwn: 'Իմ թեմաները',
  topicsIJoin: 'Թեմաներ, որոնց մասնակցում եմ',
  searchHint: 'Վերնագիր, համատեքստ և ցանկալի արդյունք։',
  clearFilters: 'Մաքրել ֆիլտրերը',
  results: 'Արդյունքներ',
  loadingTopics: 'Թեմաները բեռնվում են…',
  topicsError: 'Թեմաները չհաջողվեց բեռնել',
  topicsNone: 'Այս ֆիլտրերին համապատասխան թեմա չկա։',
  loadMoreTopics: 'Բեռնել էլի թեմաներ',
  loading: 'Բեռնվում է…',
  searchTooShort: 'Մուտքագրեք առնվազն 2 նիշ կամ մաքրեք որոնումը։',
  votePending: 'Ձեր քվեն սպասում է',
  awaitingInput: 'Սպասում է ձեր պատասխանին',
  restricted: 'Սահմանափակ',
  following: 'Հետևում եք',
  deadline: 'Վերջնաժամկետ',
  comments: 'Մեկնաբանություններ',
  notAssigned: 'Նշանակված չէ',
  priorityLow: 'Ցածր',
  priorityNormal: 'Սովորական',
  priorityHigh: 'Բարձր',
  priorityCritical: 'Կրիտիկական',
  statusDraft: 'Սևագիր',
  statusOpen: 'Բաց',
  statusDiscussing: 'Քննարկվում է',
  statusAwaitingVote: 'Սպասում է քվեարկության',
  statusDecided: 'Որոշված',
  statusExecution: 'Կատարման մեջ',
  statusClosed: 'Փակված',
  statusDeferred: 'Հետաձգված',
  statusCancelled: 'Չեղարկված',
  statusMeeting: 'Հանդիպում է պահանջվում',
  statusNoAction: 'Գործողություն չկա',
  statusQuorum: 'Քվորում չկա',
  workspaceSearch: 'Աշխատատիրույթի որոնում',
  headerSearchLabel:
    'Որոնել թեմաներ, որոշումներ, առաջադրանքներ, թարմացումներ, հանդիպումներ և նպատակներ',
  searchPlaceholder: 'Որոնել…',
  decisionRegister: 'Որոշումների մատյան',
  decisionsLead:
    'Յուրաքանչյուր գրանցված որոշում՝ աղբյուրով, կանոնով և հետագա գործողություններով։ Վերջնական որոշումները անփոփոխ են։',
  recordDecision: 'Գրանցել որոշում',
  exportCsv: 'Արտահանել CSV',
  exportDecisionsHidden: ' զտված որոշումների',
  filterDecisions: 'Զտել որոշումները',
  type: 'Տեսակ',
  anyType: 'Ցանկացած տեսակ',
  decisionsSearchHint: 'Վերնագիր, ձևակերպում և հիմնավորում։',
  loadingDecisions: 'Որոշումները բեռնվում են…',
  decisionsError: 'Որոշումները չհաջողվեց բեռնել',
  decisionsNone: 'Այս ֆիլտրերին համապատասխան որոշում չկա։',
  loadMoreDecisions: 'Բեռնել էլի որոշումներ',
  sourceTopic: 'Աղբյուր թեմա',
  none: 'Չկա',
  decided: 'Որոշվել է',
  notYet: 'Դեռ ոչ',
  effective: 'Ուժի մեջ է',
  votePrefix: 'Քվե՝ ',
  typeSimple: 'Պարզ հաստատում (քվե)',
  typeChoice: 'Բազմակի ընտրություն (քվե)',
  typeConsensus: 'Կոնսենսուս (քվե)',
  typeOwner: 'Սեփականատիրոջ որոշում',
  typeInfo: 'Տեղեկատվական',
  typeEmergency: 'Արտակարգ',
  statusFinalized: 'Վերջնականացված',
  statusDiscarded: 'Հեռացված',
  tasksLead: 'Գործողություններ մեկ պատասխանատուով, ժամկետներով, արգելափակումներով և պատմությամբ։',
  newTask: 'Նոր առաջադրանք',
  blockersWaiting: 'Ինձ սպասող արգելափակումներ',
  taskViews: 'Առաջադրանքների տեսքեր',
  tasksMine: 'Իմ առաջադրանքները',
  tasksTeam: 'Բոլոր տեսանելի առաջադրանքները',
  tasksWatching: 'Համագործակցում կամ հետևում եմ',
  tasksCreated: 'Ստեղծել եմ ես',
  filterTasks: 'Զտել առաջադրանքները',
  openTasks: 'Բաց առաջադրանքներ (չավարտված)',
  tasksSearchHint: 'Վերնագիր և նկարագրություն։',
  onlyOverdue: 'Միայն ժամկետանց առաջադրանքներ',
  loadingTasks: 'Առաջադրանքները բեռնվում են…',
  tasksError: 'Առաջադրանքները չհաջողվեց բեռնել',
  tasksNone: 'Այս ֆիլտրերին համապատասխան առաջադրանք չկա։',
  loadMoreTasks: 'Բեռնել էլի առաջադրանքներ',
  fromDecision: 'Որոշումից',
  openDecision: 'Բացել որոշումը',
  openTopic: 'Բացել թեման',
  statusDone: 'Կատարված',
  statusCancelledArchived: 'Չեղարկված կամ արխիվացված',
  statusBacklog: 'Հետաձգված',
  statusPlanned: 'Պլանավորված',
  statusInProgress: 'Ընթացքի մեջ',
  statusBlocked: 'Արգելափակված',
  statusInReview: 'Ստուգման մեջ',
  statusArchived: 'Արխիվացված',
  priorityLowFull: 'Ցածր առաջնահերթություն',
  priorityNormalFull: 'Սովորական առաջնահերթություն',
  priorityHighFull: 'Բարձր առաջնահերթություն',
  priorityCriticalFull: 'Կրիտիկական առաջնահերթություն',
  noDeadline: 'Ժամկետ չկա',
  deadlineNotSet: 'Ժամկետը նշված չէ',
  overdue: 'Ժամկետանց',
  meetingsLead:
    'Կենդանի քննարկում պահանջող թեմաները սպասում են դասավորված հերթում. օրակարգի յուրաքանչյուր կետից մնում է որոշում, առաջադրանք, հետաձգում, «գործողություն չկա» կամ հետագա թեմա։',
  newMeeting: 'Նոր հանդիպում',
  requestAgenda: 'Խնդրել օրակարգի ժամանակ…',
  requestAdded: 'Ձեր հայտը ավելացվեց օրակարգի հերթին։',
  meetingViews: 'Հանդիպումների տեսքեր',
  agendaQueue: 'Օրակարգի հերթ',
  upcomingMeetings: 'Առաջիկա հանդիպումներ',
  pastMeetings: 'Անցած հանդիպումներ',
  waitingForMeeting: 'Սպասում են հանդիպման',
  queueRank:
    'Դասավորված են ըստ առաջնահերթության, ապա ժամկետի (անցած ժամկետները առաջինը), ապա սպասման տևողության։',
  loadingQueue: 'Օրակարգի հերթը բեռնվում է…',
  queueError: 'Հերթը չհաջողվեց բեռնել',
  queueEmpty:
    'Ոչինչ չի սպասում։ «Հանդիպում է պահանջվում» թեմաները և բացահայտ հայտերը հայտնվում են այստեղ։',
  agendaQueueList: 'Օրակարգի հերթ, ամենաբարձր դիրքը առաջինը',
  withdrawTitle: 'Հետ կանչե՞լ այս հայտը։',
  withdrawConfirm: 'Հետ կանչել հայտը',
  loadingMeetings: 'Հանդիպումները բեռնվում են…',
  meetingsError: 'Հանդիպումները չհաջողվեց բեռնել',
  noUpcoming: 'Պլանավորված հանդիպում չկա։ Կազմակերպիչները կարող են պլանավորել հերթից։',
  noPast: 'Ավարտված կամ չեղարկված հանդիպում դեռ չկա։',
  loadMoreMeetings: 'Բեռնել էլի հանդիպումներ',
  goalsLead:
    'Եռամսյակային և տարեկան նպատակներ՝ ըստ ցանկության չափելի արդյունքներով։ Նպատակները ուղղություն են տալիս թեմաներին, որոշումներին և առաջադրանքներին. աշխատանքը չեն արգելափակում։',
  newGoal: 'Նոր նպատակ',
  filterGoals: 'Զտել նպատակները',
  horizon: 'Հորիզոն',
  anyHorizon: 'Ցանկացած հորիզոն',
  includeArchived: 'Ներառել արխիվացված նպատակները',
  loadingGoals: 'Նպատակները բեռնվում են…',
  goalsError: 'Նպատակները չհաջողվեց բեռնել',
  goalsNone: 'Այս ֆիլտրերին համապատասխան նպատակ չկա։',
  goalsOpen: 'Ընթացքի մեջ',
  goalsAll: 'Բոլորը, բացի չեղարկվածներից',
  goalsDrafts: 'Սևագրեր',
  goalsClosed: 'Փակված (հասած կամ բաց թողնված)',
  keyResults: 'Հիմնական արդյունքներ',
  progress: 'Առաջընթաց',
  period: 'Ժամանակաշրջան',
  quarterly: 'Եռամսյակային',
  annual: 'Տարեկան',
  customPeriod: 'Սեփական ժամանակաշրջան',
  statusAtRisk: 'Ռիսկի տակ',
  statusActive: 'Ակտիվ',
  statusAchieved: 'Հասած',
  statusMissed: 'Բաց թողնված',
  myUpdate: 'Իմ թարմացումը',
  updatesLead: 'Արված, հաջորդ, արգելափակումներ և որոշում է պետք — աշխատանքի հղումներով։',
  teamUpdates: 'Թիմի թարմացումներ',
  loadingUpdate: 'Ձեր թարմացումը բեռնվում է…',
  updatesOff:
    'Շաբաթական թարմացումները միացված չեն։ Հաշվետվության ռիթմը և պարտադիր բաժինները հիմնադիրների որոշում են, որը դեռ գրանցված չէ։',
  setSchedule: 'Սահմանել հաշվետվության ժամանակացույցը',
  noOpenPeriod: 'Բաց հաշվետու ժամանակաշրջան դեռ չկա։ Առաջինը սկսվում է սահմանված ամսաթվից։',
  searchLead:
    'Թեմաներ, մեկնաբանություններ, որոշումներ, առաջադրանքներ, շաբաթական թարմացումներ, հանդիպումների արձանագրություններ և նպատակներ, որոնք ձեզ թույլատրված է տեսնել։ Գտնվում են նաև մասնակի բառեր և մանր վրիպակներ. T-12, D-3 կամ #7-ով անցեք համարակալված կետին։',
  howToSearch: 'Ինչպես որոնել',
  wordsAndFilters: 'Բառեր և ֆիլտրեր',
  askPlain: 'Հարց տալ պարզ լեզվով',
  searchFor: 'Որոնել',
  searchKinds: 'Միայն այս տեսակները (ոչ մեկը նշված չէ = բոլորը)',
  kindTopic: 'Թեմա',
  kindComment: 'Մեկնաբանություն',
  kindDecision: 'Որոշում',
  kindTask: 'Առաջադրանք',
  kindUpdate: 'Շաբաթական թարմացում',
  kindMeeting: 'Հանդիպում',
  kindGoal: 'Նպատակ',
  authorOrOwner: 'Հեղինակ կամ սեփականատեր',
  anyone: 'Ցանկացածը',
  createdFrom: 'Ստեղծվել է սկսած',
  createdTo: 'Ստեղծվել է մինչև',
  searchWorkspace: 'Որոնել աշխատատիրույթում',
  clear: 'Մաքրել',
  searching: 'Որոնվում է…',
  searchFailed: 'Որոնումը չհաջողվեց',
  searchResults: 'Որոնման արդյունքներ',
  enterToSearch: 'Մուտքագրեք բառ, արտահայտություն կամ հղում։',
  searchMin: 'Մուտքագրեք առնվազն 2 նիշ։',
  toAfterFrom: '«Մինչև»-ը պետք է լինի «սկսած»-ից հետո կամ նույն օրը։',
  reportsLead:
    'Ինչն է ուշադրություն պահանջում, ապա գրանցված քանակներն ու գումարները։ Հիմնադիրները դասավորված են այբբենական կարգով։',
  exportReportHidden: ' այս աշխատատիրույթի հաշվետվության',
  asOf: 'Դրությամբ',
  loadingReports: 'Աշխատատիրույթի հաշվետվությունները բեռնվում են…',
  reportsError: 'Աշխատատիրույթի հաշվետվությունները չհաջողվեց բեռնել',
  executionLead:
    'Բաց աշխատանք, ժամկետանց կետեր, արգելափակումներ և հաշվետվություն՝ կողք կողքի։ Մարդիկ դասավորված են այբբենական կարգով՝ բաց, ժամկետանց և արգելափակված աշխատանքի քանակներով։',
  loadingDashboard: 'Վահանակը բեռնվում է…',
  loadingFounders: 'Հիմնադիրները բեռնվում են…',
  foundersError: 'Հիմնադիրներին չհաջողվեց բեռնել',
  noFounders: 'Հիմնադիրի պրոֆիլ դեռ չկա։',
  name: 'Անուն',
  roleAndTitle: 'Դեր և պաշտոն',
  founderSince: 'Հիմնադիր է սկսած',
  ownership: 'Սեփականություն',
  effectiveFrom: 'Ուժի մեջ է սկսած',
  source: 'Աղբյուր',
  companyFinance: 'Ընկերության ֆինանսներ',
  financeLead:
    'Եկամուտների, ծախսերի և կանխիկի կառավարման տեսք։ Յուրաքանչյուր թիվ հաշվարկվում է անփոփոխ մատյանից. ուղղումները հետադարձ գրառումներ են, ոչ թե խմբագրումներ։',
  loadingSection: 'Բաժինը բեռնվում է…',
  financeSections: 'Ֆինանսական բաժիններ',
  overview: 'Ակնարկ',
  incomeExpenses: 'Եկամուտ և ծախս',
  monthlyPnl: 'Ամսական շահույթ և վնաս',
  cashFx: 'Կանխիկ և արժույթ',
  reconciliation: 'Համաձայնեցում',
  founderFunding: 'Հիմնադիրների ֆինանսավորում',
  reserveDistributions: 'Պահուստ և բաշխումներ',
  valuation: 'Գնահատում',
  loadingFinance: 'Ֆինանսական ակնարկը բեռնվում է…',
  financeOverviewError: 'Ֆինանսական ակնարկը չհաջողվեց բեռնել',
  recordIncome: 'Գրանցել եկամուտ կամ ծախս',
  needsAttention: 'Ուշադրություն է պահանջում',
  nothingAttention: 'Այս պահին ուշադրություն չի պահանջվում։',
  warning: 'Զգուշացում',
  review: 'Դիտել',
  administration: 'Կառավարում',
  adminSections: 'Կառավարման բաժիններ',
  adminGroupPeople: 'Մարդիկ և մուտք',
  adminGroupOwnership: 'Սեփականություն և ֆինանսներ',
  adminGroupOversight: 'Վերահսկողություն',
  adminGroupSettings: 'Աշխատատիրույթի կարգավորումներ',
  adminMembers: 'Անդամներ',
  adminInvitations: 'Հրավերներ',
  adminPermissions: 'Թույլտվություններ',
  adminEquity: 'Բաժնեմաս',
  adminGovernance: 'Կառավարման կանոններ',
  adminAudit: 'Աուդիտի մատյան',
  adminAi: 'ԱԲ-ի գործունեություն',
  adminExecution: 'Կատարում և հաշվետվություն',
  adminSecurity: 'Անվտանգության կարգավորումներ',
  adminSystem: 'Համակարգի կարգավիճակ',
  notificationsLead: 'Քվեներ, հիշատակումներ, որոշումներ և ժամկետներ, որոնք վերաբերում են ձեզ։',
  notificationSettings: 'Ծանուցումների կարգավորումներ',
  markAllRead: 'Նշել բոլորը որպես կարդացած',
  unreadOnly: 'Ցույց տալ միայն չկարդացածները',
  loadingNotifications: 'Ծանուցումները բեռնվում են…',
  notificationsError: 'Ծանուցումները չհաջողվեց բեռնել',
  noUnread: 'Չկարդացած ծանուցում չունեք։',
  nothingUnread: 'Չկարդացած ոչինչ չկա։',
  noNotificationsYet: 'Ծանուցում դեռ չկա։',
  meetingNotScheduled: 'Դեռ պլանավորված չէ',
  meetingScheduled: 'Պլանավորված',
  meetingCompleted: 'Ավարտված',
  cancel: 'Չեղարկել',
  reason: 'Պատճառ',
  reasonMin: 'Մուտքագրեք առնվազն 3 նիշանոց պատճառ։',
  recordedInAudit: 'Գրանցվում է աուդիտի մատյանում։',
  working: 'Կատարվում է…',
  actions: 'Գործողություններ',
  when: 'Երբ',
  applyFilters: 'Կիրառել ֆիլտրերը',
  loadMore: 'Բեռնել էլի',
  on: 'Միացված',
  off: 'Անջատված',
  member: 'Անդամ',
  saveChanges: 'Պահել փոփոխությունները',
  saveSettings: 'Պահել կարգավորումները',
  checkingServices: 'Ծառայությունները ստուգվում են…',
  apiUnreachable: 'API-ն անհասանելի է։ Ստուգեք, որ այն աշխատում է։',
  statusUnknown: 'Ծառայությունների կարգավիճակը չհաջողվեց որոշել։',
  allOperational: 'Բոլոր ծառայություններն աշխատում են։',
  someUnavailable: 'Որոշ ծառայություններ անհասանելի են։',
  operational: 'Աշխատում է',
  unavailable: 'Անհասանելի',
  database: 'Տվյալների բազա',
  cacheQueues: 'Քեշ և հերթեր',
  checkAgain: 'Ստուգել կրկին',
  checking: 'Ստուգվում է…',
  loadingAudit: 'Աուդիտի գրառումները բեռնվում են…',
  auditNone: 'Այս ֆիլտրերին համապատասխան աուդիտի գրառում չկա։',
  auditEvents: 'Աուդիտի գրառումներ',
  action: 'Գործողություն',
  entity: 'Օբյեկտ',
  actor: 'Կատարող',
  details: 'Մանրամասներ',
  showChanges: 'Ցույց տալ փոփոխությունները',
  before: 'Առաջ',
  after: 'Հետո',
  filterAudit: 'Զտել աուդիտի գրառումները',
  entityType: 'Օբյեկտի տեսակ',
  entityTypeHint: 'օր. member, founder_profile, cap_table_version',
  entityTypeError: 'Օգտագործեք փոքրատառեր և ընդգծումներ, օր. member կամ cap_table_version։',
  entityId: 'Օբյեկտի ID',
  entityIdError: 'Օգտագործեք ամբողջական ID (UUID)։',
  aiConfigError: 'ԱԲ-ի կարգավորումը չհաջողվեց բեռնել',
  aiLead:
    'ԱԲ մատակարարին ուղարկված յուրաքանչյուր հարցում գրանցվում է մոդելով, ձևանմուշի տարբերակով և տվյալների քաղաքականությամբ։ Հարցումների և պատասխանների տեքստն այս մատյանում չի պահվում։',
  loadingAi: 'ԱԲ-ի գործունեությունը բեռնվում է…',
  aiNone: 'ԱԲ օգնականը դեռ չի օգտագործվել։',
  aiActivity: 'ԱԲ-ի գործունեություն',
  purpose: 'Նպատակ',
  requestedBy: 'Խնդրել է',
  model: 'Մոդել',
  dataCol: 'Տվյալներ',
  usage: 'Օգտագործում',
  plainSearch: 'Որոնում պարզ լեզվով',
  systemActor: 'Համակարգ',
  notSent: 'Չի ուղարկվել',
  sentWorkspace: 'Ուղարկվել է (աշխատատիրույթի բովանդակություն)',
  sentAggregates: 'Ուղարկվել է (միայն ամփոփ թվեր)',
  aiConfiguration: 'ԱԲ-ի կարգավորում',
  provider: 'Մատակարար',
  notConfigured: 'Կարգավորված չէ',
  workspaceContent: 'Աշխատատիրույթի բովանդակություն',
  mayBeSent: 'Կարող է ուղարկվել',
  neverSent: 'Երբեք չի ուղարկվում',
  financialFigures: 'Ֆինանսական թվեր',
  aggregatesMay: 'Ամփոփ թվերը կարող են ուղարկվել',
  aiEnvNote:
    'Այս կարգավորումները գալիս են սերվերի միջավայրից (AI_PROVIDER, AI_CONTENT_DATA_POLICY, AI_FINANCE_DATA_POLICY) և փոխվում են միայն տեղակայմամբ։',
  loadingSecurity: 'Անվտանգության կարգավորումները բեռնվում են…',
  securitySaved: 'Անվտանգության կարգավորումները պահվել են։',
  mfaForFounders: 'Երկքայլ ստուգում սեփականատիրոջ և հիմնադիրների համար.',
  required: 'Պարտադիր',
  optional: 'Կամընտիր',
  requireMfa: 'Պահանջել երկքայլ ստուգում սեփականատիրոջից և հիմնադիրներից',
  requireMfaHint: 'Առանց դրա անդամներին կառաջարկվի միացնել այն զգայուն աշխատանքից առաջ։',
  requireMfaTitle: 'Պահանջե՞լ երկքայլ ստուգում։',
  optionalMfaTitle: 'Երկքայլ ստուգումը դարձնե՞լ կամընտիր։',
  requireMfaDesc:
    'Առանց երկքայլ ստուգման հիմնադիրներն ու սեփականատերը պետք է միացնեն այն շարունակելուց առաջ։',
  optionalMfaDesc:
    'Սա իջեցնում է աշխատատիրույթի անվտանգության պահանջը։ Փոփոխությունը գրանցվում է աուդիտում։',
  saveSetting: 'Պահել կարգավորումը',
  policyLead:
    'Ինչպես է աշխատատիրույթը ուղարկում ծանուցումները էլ. փոստով։ Անդամներն ընտրում են իրենց ալիքներն ու լուռ ժամերը. կառավարման կարևոր ծանուցումները միշտ ուղարկվում են։',
  loadingPolicy: 'Ծանուցումների քաղաքականությունը բեռնվում է…',
  emailDelivery: 'Էլ. փոստի առաքում և հիշեցումներ',
  defaultsInEffect: 'Գործում են փաստաթղթավորված լռելյայնները',
  savedByWorkspace: 'Պահված է աշխատատիրույթի կողմից',
  bundleEmails: 'Ոչ կարևոր նամակները հավաքել (րոպե)',
  bundleHint: 'Այս պատուհանի իրադարձությունները գնում են մեկ նամակով։ 0 = ուղարկել անմիջապես։',
  bundleError: 'Մուտքագրեք ամբողջ թիվ 0-ից 240։',
  remindCritical: 'Չկարդացած կարևոր ծանուցումների հիշեցում յուրաքանչյուր (ժամ)',
  remindHint: 'Քվեներ, կարևոր թեմաներ և վերջնական որոշումներ։ 0 = առանց հիշեցման։',
  remindError: 'Մուտքագրեք ամբողջ թիվ 0-ից 336։',
  maxReminders: 'Առավելագույն հիշեցումներ մեկ ծանուցման',
  maxRemindersHint: 'Այսքան հիշեցումից հետո սրումը դադարում է։',
  maxRemindersError: 'Մուտքագրեք ամբողջ թիվ 0-ից 10։',
  policySaved: 'Ծանուցումների քաղաքականությունը պահվել է։',
  savePolicyButton: 'Պահել ծանուցումների քաղաքականությունը…',
  savePolicyTitle: 'Պահե՞լ ծանուցումների քաղաքականությունը։',
  savePolicyDesc:
    'Նոր արժեքները կիրառվում են այս պահից ստեղծված ծանուցումների վրա։ Փոփոխությունը գրանցվում է աուդիտում։',
  savePolicy: 'Պահել քաղաքականությունը',
  loadingMembers: 'Անդամները բեռնվում են…',
  twoStepCol: 'Երկքայլ',
  deactivate: 'Ապաակտիվացնել',
  reactivate: 'Վերակտիվացնել',
  edit: 'Խմբագրել',
  deactivateDesc:
    'Նրանք անմիջապես կկորցնեն մուտքը այս աշխատատիրույթ։ Պատմությունը, քվեները, պարտքերը և գրառումները պահվում են։',
  reactivateDesc: 'Նրանք կվերադարձնեն մուտքը իրենց ներկայիս դերով։',
  deactivateMember: 'Ապաակտիվացնել անդամին',
  reactivateMember: 'Վերակտիվացնել անդամին',
  titleHint: 'Թողեք դատարկ՝ պաշտոնը հանելու համար։',
  ownerRoleFixed: 'Սեփականատիրոջ դերը այստեղ չի փոխվում։',
  roleChangeHint:
    'Դերի փոփոխությունը պահանջում է վերջերս հաստատված ինքնություն և գրանցվում է աուդիտում։',
  roleChangeReason: 'Դերի փոփոխության պատճառ',
  changeFirst: 'Նախ փոխեք պաշտոնը կամ դերը։',
  sentInvitations: 'Ուղարկված հրավերներ',
  loadingInvitations: 'Հրավերները բեռնվում են…',
  resendFailed: 'Կրկին ուղարկելը չհաջողվեց',
  noInvitations: 'Հրավեր դեռ չկա։',
  expires: 'Լրանում է',
  invitedBy: 'Հրավիրել է',
  resend: 'Կրկին ուղարկել',
  revoke: 'Չեղարկել',
  revokeInvitation: 'Չեղարկե՞լ հրավերը։',
  revokeInvitationDesc: 'Հղումն այլևս չի աշխատի։ Այս հասցեն կարող եք հրավիրել ավելի ուշ։',
  revokeInvitationConfirm: 'Չեղարկել հրավերը',
  inviteSomeone: 'Հրավիրել',
  titleOptionalHint: 'Կամընտիր, օր. CTO։',
  sendInvitation: 'Ուղարկել հրավեր',
  invitationSent: 'Հրավերը ստեղծվել է։',
  grantsLead:
    'Թույլտվությունը դերին ավելացնում է մեկ բացահայտ իրավունք։ Տալը և չեղարկելը պահանջում են վերջերս հաստատված ինքնություն և գրանցվում են աուդիտում։',
  grants: 'Թույլտվություններ',
  noGrants: 'Լրացուցիչ թույլտվություն չկա։',
  permission: 'Թույլտվություն',
  grantedBy: 'Տվել է',
  active: 'Ակտիվ',
  revoked: 'Չեղարկված',
  revokePermission: 'Չեղարկե՞լ թույլտվությունը։',
  grantPermission: 'Տալ թույլտվություն',
  membersLoadError: 'Անդամներին չհաջողվեց բեռնել',
  chooseMember: 'Ընտրեք անդամ',
  choosePermission: 'Ընտրեք թույլտվություն',
  decisionId: 'Որոշման ID',
  decisionIdHint: 'Կամընտիր. հիմնադիրների որոշման ID, որը հաստատել է այս թույլտվությունը։',
  grantThis: 'Տա՞լ այս թույլտվությունը։',
  founderProfiles: 'Հիմնադիրների պրոֆիլներ',
  createFounder: 'Ստեղծել հիմնադիրի պրոֆիլ',
  everyMemberHasProfile: 'Յուրաքանչյուր ակտիվ անդամ արդեն ունի հիմնադիրի պրոֆիլ։',
  capAsOf: 'Ցույց տալ բաժնեմասը այս օրվա դրությամբ',
  capAsOfHint:
    'Թողեք դատարկ՝ այսօրվա համար։ Գործում է հաստատված տարբերակը՝ այս օրվան նախորդող կամ հավասար ամենաուշ ուժի մեջ մտնելու ամսաթվով։',
  noCapVersions: 'Բաժնեմասի տարբերակ դեռ չկա։ Ստեղծեք առաջին սևագիրը վերևում։',
  tasksAndBlockers: 'Առաջադրանքներ և արգելափակումներ',
  weeklyFounderUpdates: 'Հիմնադիրների շաբաթական թարմացումներ',
  reportingRules: 'Հաշվետվության կանոններ',
  categories: 'Կատեգորիաներ',
  noCategories: 'Կատեգորիա դեռ չկա։',
  dataSources: 'Տվյալների աղբյուրներ',
  categoryPolicies: 'Կատեգորիաների քաղաքականություն',
};
